import { handleResponseOld } from './helpers';

/**
 * calls express-healthcheck to verify bidder-react server status
 * @function fetchHealthCheckData
 * @category Bidder React API
 * @see https://github.com/lennym/express-healthcheck
 * @see https://github.com/LIVEauctioneers/bidder-react/blob/cfa674947011ddb78f6ded7a7419deb9431f7686/src/server/server.js#L196
 */
const fetchHealthCheckData = () =>
    new Promise<any>(async (resolve, reject) => {
        try {
            const response = await fetch('/healthcheck');
            const body = await response.json().catch(() => ({}));

            // Convert Headers object to plain object for backward compatibility
            const headers: Record<string, string> = {};
            response.headers.forEach((value, key) => {
                headers[key] = value;
            });

            const formattedResponse = { body, headers, ok: response.ok, status: response.status };

            if (!response.ok) {
                const error = new Error(`Request failed with status ${response.status}`);
                (error as any).status = response.status;
                return handleResponseOld({ err: error, reject, resolve, response: formattedResponse });
            }

            handleResponseOld({ err: null, reject, resolve, response: formattedResponse });
        } catch (error) {
            handleResponseOld({ err: error, reject, resolve, response: {} });
        }
    });

export default {
    fetchHealthCheckData,
};
